/**
 * Muestra una sola vez la clave temporal que genero el reseteo.
 */

import { useState } from 'react';
import { Button } from '@presentation/components/common';
import type { ResetPasswordResult } from '@application/dto';
import styles from '../admin.module.css';

interface TemporaryPasswordPanelProps {
  result: ResetPasswordResult;
  onClose: () => void;
}

export function TemporaryPasswordPanel({ result, onClose }: TemporaryPasswordPanelProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(result.temporaryPassword);
      setCopied(true);
    } catch {
      // Sin permiso de portapapeles: la clave sigue a la vista para copiarla a mano.
    }
  };

  return (
    <section className={styles.panel} aria-live="polite">
      <header className={styles.header}>
        <div>
          <h2 className={styles.title}>Clave temporal de {result.email}</h2>
          <p className={styles.subtitle}>
            Pasásela al usuario por un canal seguro. Al entrar, el sistema le pide elegir una
            nueva. Vence en 3 días y no se vuelve a mostrar.
          </p>
        </div>
      </header>

      <div className={styles.actions}>
        <code>{result.temporaryPassword}</code>
        <Button size="small" variant="secondary" onClick={() => void copy()}>
          {copied ? 'Copiada' : 'Copiar'}
        </Button>
        <Button size="small" onClick={onClose}>
          Listo
        </Button>
      </div>
    </section>
  );
}
